import React from 'react';
import { Img } from '@raketa-cms/raketa-cms';

const MosaicItem = ({ variant, link, image, title, description }) => {
  if (title !== '') return (
    <a href={link} className="mosaic-item">
      <div>
        <Img src={image} variant={variant} />
        <Img src={image} variant="square" />
      </div>

      <div className="overlay-content">
        <h3 className="title">{title}</h3>
        {description && <h5 className="sub-title">{description}</h5>}
      </div>
    </a>
  );

  return (<Img src={image} variant={variant} />);
};

export default MosaicItem;
